﻿import {Core} from "../Base/Core";
import {UICommonPopup} from "./Tools/Base/UICommonPopup";
import {UISprite} from "./Tools/Base/UISprite";

export class PausePopup extends UICommonPopup {

    Awake() {
        super.Awake({});
        this.back.visible = false;

        this.btn = this.content.addChild(new UISprite("ring-glow"));
        this.btn.interactive = true;
        this.btn.cursor = "pointer";
        this.btn.alpha = 0.5;
        this.icon = this.btn.addChild(new UISprite("play-icon"));

        this.btn.on("pointertap", () => {
            Core.SetPause(false);
        });
    }

    fitLayout(viewport = Core.app.viewport) {
        let size = viewport.width * 0.4;
        this.setPopupSize(size, size);
        super.fitLayout(viewport);

        let contentRect = this.getContentSize();

        let rect = contentRect.clone();
        this.btn.fitRect(rect);

        this.icon.scale.set(1.2);
        this.icon.x = 5;
    }

    Show() {
        this.visible = true;
        this.Active = true;
        this.fitLayout();
    }

    Hide() {
        this.visible = false;
        this.Active = false;
    }

}
